export default __webpack_public_path__ + "00a5a6fef408affae14d92c1d5d3d541.gltf";